import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ProjectMedia } from '../models/project-media.model';
import { CommunicationManagerService } from './communication-manager.service';
import { parse } from 'date-fns';
import { BehaviorSubject, finalize } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private projectId: string;

   

  private reloadingMedia = new BehaviorSubject<boolean>(false);
  //TODO: see about injecting projectId in the constructor
  // google "angular inject service in constructor with parameter" results
  constructor(private cm: CommunicationManagerService) {
    this.projectId = '';
  }

  public getReloadingMedia() {
    return this.reloadingMedia.asObservable();
  }
  public setReloadingMedia(reloading: boolean) {
    this.reloadingMedia.next(reloading);
  }

  public setProjectId(projectId: string) {
    this.projectId = projectId;
  }
  public getProjectMedia(projectId: string) {
    this.projectId = projectId;
    this.reloadingMedia.next(true);
    return this.cm.get('media/all', [
      { headerName: 'projectId', headerValue: projectId },
    ]).pipe(
      finalize(() => {
        this.reloadingMedia.next(false);
      })
    );
  }

  public addProjectMedia(mediaType: string) {
    return this.cm.postAndGetJson('media/', { type: mediaType }, [
      { headerName: 'projectId', headerValue: this.projectId },
    ]);
  }
  public duplicateProjectMedia(mediaId: string) {
    return this.cm.get('media/clone/' + mediaId, [
      { headerName: 'projectId', headerValue: this.projectId },
    ]);
  }
  public deleteProjectMedia(mediaId: string) {
    return this.cm.delete('media/' + mediaId, [
      { headerName: 'projectId', headerValue: this.projectId },
    ]);
  }

  public saveMediaUsageStart(value: Date, mediaId: string) {
    const payload = {
      startDate: value?.toLocaleDateString('en-US') as any,
      actionUponCompletion: '',
      extension: '',
      startDateChange: value,
    };
    this.cm
      .put(`media/usageStart/${mediaId}`, payload, [
        { headerName: 'projectId', headerValue: this.projectId },
      ])
      .subscribe();
  }

  public updateMedia(projectId: string, mediaToUpdate: any) {
    const mediaId = mediaToUpdate._id;
    //console.log(mediaId);
    const mediaDTO = this.cleanUpProjectMediaObject(mediaToUpdate);

    return this.cm.put(`media/${mediaId}`, mediaDTO, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public updateAll(
    projectId: string,
    fieldsToUpdate: {
      title?: string;
      quantity?: number;
      usageLength?: string;
      usageMedium?: string;
    }
  ) {
    if (!fieldsToUpdate) return;

    return this.cm.put(`media/apply`, fieldsToUpdate, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  isProjectMediaKey(key: string): key is keyof ProjectMedia {
    return [
      '_id',
      'type',
      'title',
      'quantity',
      'usageLength',
      'usageMedium',
      'region',
      'usageStart',
      'description',
      'visible',
    ].includes(key);
  }

  cleanUpProjectMediaObject(mediaObject: ProjectMedia): ProjectMedia {
    const unspecifiedFields: Array<string> = [
      '__v',
      '_id',
      'createdAt',
      'updatedAt',
      'project',
      'deletedAt',
      'type',
    ];
    const clone = _.cloneDeep(mediaObject);
    Object.keys(clone).forEach((field) => {
      if (this.isProjectMediaKey(field) && unspecifiedFields.includes(field)) {
        delete clone[field];
      }
    });
    if (clone.usageStart) {
      const startDate = clone.usageStart.startDate;

      if (typeof startDate === 'string') {
        // Parse the string to a Date object
        const splitTime = (startDate as string).split('T')[0];
        const parsedDate = parse(splitTime, 'yyyy-MM-dd', new Date()); // Assuming input is in ISO format
        if (isNaN(parsedDate.getTime())) {
          // Invalid date string
          clone.usageStart.startDate = null as any;
        } else {
          // Valid date string
          clone.usageStart.startDate =
            (parsedDate.toLocaleDateString('en-US') as any) ?? null;
        }
      } else if (startDate instanceof Date) {
        // It's already a Date object
        clone.usageStart.startDate =
          (clone?.usageStart?.startDate?.toLocaleDateString('en-US') as any) ??
          null;
      } else {
        // Handle any other cases (e.g., null or undefined)
        clone.usageStart.startDate = null as any;
      }
    }
    return clone;
  }
}
